import React, { Fragment, useEffect, useState } from 'react';
import MaskedText from "./MaskedText";

const FlightNumber = props => {
  const [state, setState] = useState({
    code: props.code ? props.code : "",
    number: props.number ? props.number : "",
    defaultCode: props.defaultCode,
    defaultNumber: props.defaultNumber,
    inputProps: props.inputProps,
    mask: "aa-999aX"
  });

  useEffect(()=> {
    if ((props.code||'') !== state.code || (props.number||'') !== state.number)
      setState({...state, code: props.code||'', number: props.number||''});
  }, [props.code, props.number])

  /*
  This can be used to customise the mask behaviour

  const beforeMaskedValueChange = (newState, oldState, userInput, maskOptions) => {
    let { value } = newState;
    let selection = newState.selection;
    let cursorPosition = selection ? selection.start : null;

    let newValue = value.trim();
    let oldValue = oldState.value.trim();
    if (newValue.length === 3 &&  cursorPosition === newValue.length && oldValue.length < newValue.length) {
      value = newValue + "-";
      cursorPosition ++;
      selection = { start: cursorPosition, end: cursorPosition };
    }
    if (newValue.length === 4 &&  cursorPosition === newValue.length && newValue.length < oldValue.length) {
      value = newValue.slice(0, 3);
      cursorPosition--;
      selection = { start: cursorPosition, end: cursorPosition };
    }

    const emptyValue = " ".repeat(maskOptions.mask.length);
    value = value + emptyValue.substr(0, emptyValue.length - value.length);
    return {
      value,
      selection
    };
  };


   */

  const handleChange = newValue => {
    // console.log(newValue);
    const separatorPos = newValue.indexOf('-');
    const code = newValue.substr(0, separatorPos < 0 ? newValue.length : separatorPos);
    const number = separatorPos < 0 ? "" : newValue.substr(separatorPos + 1, newValue.length - separatorPos);
    // console.log(number);
    setState({...state, code: code, number: number});
    props.onChange({...state, code: code, number: number, action: "code"});
  };

  const formatChars={
    "U": "[A-Z]",
    "X": "[A-Za-z]",
    "A": "[A-Z0-9]",
    "a": "[A-Za-z0-9]",
    "i": "[A-Za-z0-9]-",
    "9": "[0-9]",
    "D": "[0-9.]",
    "x": "."
  }

  return (
    <Fragment>
      <MaskedText
        id={props.id}
        mask={state.mask}
        maskChar={""}
        alwaysShowMask={true}
        //beforeMaskedValueChange={beforeMaskedValueChange}
        formatChars={formatChars}
        permanents={[3]}
        forceUpperCase={true}
        value={state.code +"-"+ state.number}
        variant={props.variant || 'standard'}
        label={props.label || ""}
        required={props.required || false}
        onChange={handleChange}
        inputProps={state.inputProps}
        readOnly={props.readOnly}
      />
    </Fragment>
  )
};

export default FlightNumber;
